import { createContext, useContext } from 'react';
export var HlsContext = /*#__PURE__*/createContext(undefined);
export var useHlsContext = function useHlsContext() {
  var context = useContext(HlsContext);
  if (context === undefined) {
    throw new Error('useHlsContext must be used within a HlsProvider component');
  }
  return context;
};